import axios from 'axios'
import {LoanEligibilityLogParams} from '../Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const LOAN_ELIGIBILITY_LOG_URL = `${API_URL}/loan-eligibility-log`

export const service = {
  getLoanEligibilityLog: (params: LoanEligibilityLogParams) =>
    axios.get(LOAN_ELIGIBILITY_LOG_URL, {params}),

  exportLoanEligibilityLog: (params: Omit<LoanEligibilityLogParams, 'page' | 'limit'>) =>
    axios.get(`${LOAN_ELIGIBILITY_LOG_URL}/export`, {params, responseType: 'blob'}),

  getLetter: (id: string) =>
    axios.get(`${LOAN_ELIGIBILITY_LOG_URL}/${id}/letter`, {responseType: 'blob'}),

  // filter options: the loan types offered on the eligibility form, and all branches
  getLoanTypes: () => axios.get(`${API_URL}/frontend/loan-eligibility/products`),
  getBranches: () => axios.get(`${API_URL}/branch/list`),
}
